/**
 * feature-config flag names owned by aeo
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const AEO_DYNAMIC_CONFIG_NAMES = {
  AEO_MODEL_CONFIG: 'dc-aeo-480-aeo-model-config',
  AEO_SCHEDULING_GLOBAL_CONFIG: 'dc-aeo-521-seoaudit-scheduling-global-config',
  AEO_INTERNAL_AUDIT_ALLOWLIST: 'dc-aeo-1148-internal-audit-allowlist',
  AEO_SEOAUDIT_CONCURRENCY: 'dc-aeo-1356-seoaudit-concurrency',
  AEO_PUBLIC_CONCURRENCY_LIMIT: 'dc-opt-3819-aeo-public-concurrency-limit',
  AEO_AUDIT_PIPELINE_DISABLE_LISTS: 'dc-aeo-1456-audit-pipeline-disable-lists',
  AEO_RECS_MODEL_CONFIG: 'dc-wfa-2633-aeo-recs-model-config',
} as const;

export const AEO_FLAG_NAMES = {
  SLACK_INTEGRATION_AUTHORIZATION:
    'ff-aeo-1753-slack-integration-authorization',
  INTEGRATION_CREDENTIAL_REFRESH: 'ff-aeo-1847-integration-credential-refresh',
  AEO_MEASUREMENT: 'ff-aeo-64-aeo-measurement',
  AEO_IN_SOURCE: 'ff-wfa-2262-aeo-in-source',
  AEO_PROMPT_EXECUTION: 'ff-aeo-184-prompt-execution',
  AEO_PROMPT_RESPONSE_STORAGE: 'ff-aeo-232-prompt-response-storage',
  AEO_PROMPT_DISCOVERY: 'ff-aeo-471-prompt-discovery',
  AEO_PROMPT_DETAIL: 'ff-wfa-2133-prompt-detail',
  AEO_RAW_PROMPT_INSIGHTS_TABLE: 'ff-aeo-327-raw-prompt-insights-table',
  AEO_SCHEDULER_V2: 'ff-aeo-96-scheduler-v2',
  AEO_SITE_AUDIT_LOCALIZATION: 'ff-aeo-361-site-audit-localization',
  AEO_DEMO_MODE: 'ff-aeo-106-analytics-demo-mode',
  AEO_NO_ENTITLEMENTS: 'ff-aeo-103-analytics-no-entitlements',
  AEO_AUTO_PROVISION_ENTERPRISE: 'ff-aeo-104-auto-provision-enterprise',
  AEO_RECURRING_AUDIT_CRON: 'ff-aeo-521-recurring-audit-cron',
  AEO_ARCHIVE_SYNC: 'ff-wfa-2157-aeo-storage-sync',
  AEO_GEMINI_FANOUT: 'ff-aeo-699-gemini-fanout',
  AEO_IMAGE_ALT_TEXT_HASH_DEDUPE: 'ff-aeo-1339-image-alt-text-hash-dedupe',
  AEO_AUDIT_PERFORMANCE_FIXES: 'ff-aeo-1772-audit-performance-fixes',
  AEO_OPENAI_FANOUT: 'ff-wfa-2163-openai-fanout',
  AEO_ANTHROPIC_FANOUT: 'ff-wfa-2159-anthropic-fanout',
  AEO_PERPLEXITY_FANOUT: 'ff-wfa-2257-perplexity-fanout',
  AI_WORKFLOWS_M1: 'ff-aeo-1193-ai-workflows-m1',
  // Gates AI-credit reporting/deduction for agentic-workflow runs (AEO-1229).
  // OFF during the content-agents beta so beta runs don't deduct real credits;
  // flip ON at GA (then remove the flag). Enforcement stays soft regardless.
  AI_WORKFLOWS_CREDIT_REPORTING: 'ff-aeo-1229-ai-workflows-credit-reporting',
  AEO_PUBLIC_BOT_TRAFFIC_ENABLED: 'ff-aeo-public-bot-traffic-enabled',
  AEO_PUBLIC_BOT_TRAFFIC_PAGES_ENABLED:
    'ff-aeo-public-bot-traffic-pages-enabled',
  AEO_PUBLIC_PROMPTS_ENABLED: 'ff-aeo-public-prompts-enabled',
  AEO_PUBLIC_PROMPT_EXECUTIONS_ENABLED:
    'ff-aeo-public-prompt-executions-enabled',
  AEO_PUBLIC_PROMPT_EXECUTION_DETAIL_ENABLED:
    'ff-aeo-public-prompt-execution-detail-enabled',
  AEO_PUBLIC_VISIBILITY_ENABLED: 'ff-aeo-public-visibility-enabled',
  AEO_PUBLIC_VISIBILITY_BREAKDOWN_ENABLED:
    'ff-aeo-public-visibility-breakdown-enabled',
  AEO_PUBLIC_CITATION_RATE_ENABLED: 'ff-aeo-public-citation-rate-enabled',
  AEO_PUBLIC_TOP_CITED_DOMAINS_ENABLED:
    'ff-aeo-public-top-cited-domains-enabled',
  AEO_PUBLIC_CITED_DOMAIN_PATHS_ENABLED:
    'ff-aeo-public-cited-domain-paths-enabled',
  AEO_PUBLIC_PAGE_CITATION_SHARE_ENABLED:
    'ff-aeo-public-page-citation-share-enabled',
  AEO_PUBLIC_COMPETITOR_CITATIONS_ENABLED:
    'ff-aeo-public-competitor-citations-enabled',
  AEO_PUBLIC_CITATIONS_ENABLED: 'ff-aeo-public-citations-enabled',
  AEO_PUBLIC_RECOMMENDATIONS_ENABLED: 'ff-aeo-public-recommendations-enabled',
  // Second gate on the public recommendations lifecycle writes (dismiss,
  // restore, apply, bulk, audits, tasks), checked in addition to
  // AEO_PUBLIC_RECOMMENDATIONS_ENABLED so writes can roll out after reads.
  AEO_PUBLIC_RECOMMENDATIONS_WRITE_ENABLED:
    'ff-aeo-public-recommendations-write-enabled',
  AEO_PUBLIC_PER_TOKEN_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-opt-3819-aeo-public-per-token-concurrency-limit-enforce-enabled',
  AEO_PUBLIC_WEBFLOW_DRUID_AGGREGATE_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-opt-3819-aeo-public-webflow-druid-aggregate-concurrency-limit-enforce-enabled',
  AEO_PUBLIC_INTELLIMIZE_DRUID_AGGREGATE_CONCURRENCY_LIMIT_ENFORCE_ENABLED:
    'ff-opt-3819-aeo-public-intellimize-druid-aggregate-concurrency-limit-enforce-enabled',
  AEO_INSTRUCTION_CONTEXT_MAPPING: 'ff-aeo-1553-instruction-context-mapping',
};
